var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"aef-faq"},[_c('v-container',{attrs:{"fluid":""}},[_c('object',{attrs:{"data":_vm.link,"type":"application/pdf","width":"100%","height":"800px"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }